export enum ConnectedAccountTransactionRfiStatus {
    Pending = 'pending',
    Submitted = 'submitted',
    Active = 'active',
    Suspended = 'suspended',
    ActionRequired = 'action-required',
    Disabled = 'disabled',
}
